module.exports = __webpack_public_path__ + "static/media/My Song 43.d28a0b84.m4a";